import { render, staticRenderFns } from "./BookingsOverviewTable.vue?vue&type=template&id=5f2e0dae&lang=pug&"
import script from "./BookingsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./BookingsOverviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports